import { axios } from '../../clients/axios'
import { API_URL } from '../../config/env'
import { formatCurrency } from '../../util/currency'
import { YYYYMMDD, dayjs } from '../../util/date'
import { getTenantName } from '../../util/user'
import { parsePaymentStatus } from '../../config/payment'

const headers = [
  { value: 'refNo', text: 'ID' },
  { value: 'paymentRefNo', text: 'Payment' },
  { value: 'unitName', text: 'Unit' },
  { value: 'tenantName', text: 'Tenant', width: '20%' },
  { value: 'amount', text: 'Amount' },
  { value: 'status', text: 'Status' },
  { value: 'startDate', text: 'Start Date' },
  { value: 'endDate', text: 'End Date' }
]

export default {
  namespaced: true,
  state: {
    downPayments: [],
    totalCount: 0
  },
  getters: {
    getHeaders: () => headers,
    getCount: (state) => state.totalCount,
    getDownPayments: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      const units = rootGetters['units/getUnitsFlat']

      return state.downPayments.map((downPayment) => {
        const unit = units.find(
          (u) => u.bedId === parseInt(downPayment.lease_details.bedId)
        )
        return {
          ...downPayment,
          paymentRefNo:
            downPayment.payment_details && downPayment.payment_details.refNo,
          dateCreated: dayjs(downPayment.dateCreated).format(YYYYMMDD),
          paymentDueDate: downPayment.paymentDueDate
            ? dayjs(downPayment.paymentDueDate).format(YYYYMMDD)
            : '',
          tenantName: getTenantName(
            aliases,
            downPayment.tenantId,
            downPayment.tenant_details
          ),
          formattedAmount: formatCurrency(downPayment.amount),
          parsedStatus: parsePaymentStatus(downPayment.status),
          unitName: unit && unit.bedName,
          startDate: dayjs(downPayment.startDate).format(YYYYMMDD),
          endDate: dayjs(downPayment.endDate).format(YYYYMMDD)
        }
      })
    }
  },
  mutations: {
    fetchDownPayments(state, downPayments) {
      state.downPayments = downPayments
    },
    fetchCount(state, count) {
      state.totalCount = count
    }
  },
  actions: {
    async searchDownPaymentsAction(context, params) {
      const paramsToSend = params
      // remove empty string / falsy attributes
      Object.keys(paramsToSend).forEach(
        (k) => !paramsToSend[k] && delete paramsToSend[k]
      )
      paramsToSend.page = (params.page || 1) - 1

      const response = await axios.get(`${API_URL}/downPayments/search`, {
        params: paramsToSend,
        withCredentials: true
      })

      const result = response.data
      context.commit('fetchDownPayments', result.downPayments)
      context.commit('fetchCount', result.count)

      return {
        count: result.count,
        limit: params.limit,
        downPayments: result.downPayments
      }
    },
    async cancel(context, params) {
      const { _id } = params

      const response = await axios.post(
        `${API_URL}/downPayments/cancel`,
        {
          _id
        },
        {
          withCredentials: true
        }
      )

      return response.data
    }
  }
}
